export const navbarBg = 'navbar-theme';
export const sidenavBg = 'primary sidenav-dark';
export const footerBg = 'footer-theme';
